import { Script } from "gatsby";
import React, { FC } from "react";
import * as Styled from "./styled";
import { useEventContext } from '../../context/EventProvider';

export type EventbriteOrderCompleteEvent = {
  orderId: string;
};

export interface EventbriteWidgetProps {
  eventId?: string;
  widgetType?: string;
  iframeContainerId?: string;
  modalTriggerElementId?: string;
  iframeContainerHeight?: number;
  onOrderComplete?: (event: EventbriteOrderCompleteEvent) => void;
}
export const EventbriteRegistration: FC<EventbriteWidgetProps> = ({
  eventId,
  ...props
}) => {
  const { event: {
    externalRegistrationEmbedId,
    externalRegistrationVirtualEmbedId
  }, virtual } = useEventContext();

  const embedId = virtual ? externalRegistrationVirtualEmbedId : externalRegistrationEmbedId;

  return (
    <Styled.RegistrationForm className="form-register">
      <Script
        src="https://www.eventbrite.com/static/widgets/eb_widgets.js"
        onLoad={() => {
          window.EBWidgets.createWidget({
            widgetType: "checkout",
            iframeContainerId: "eventbrite-container",
            iframeContainerHeight: 700,
            eventId: embedId,
            ...props,
          });
        }}
        onError={() => console.log("Error loading Eventbrite widget script")}
      />
      <div id="eventbrite-container"></div>
    </Styled.RegistrationForm>
  );
};

export default EventbriteRegistration;
